import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { DealEstimationHistoryContext } from '~/models/DealEstimationHistory';
import type { DealEstimationHeader } from '~/models/DealEstimationHeader';

const paths = {
  index: '/vendors/deals/:deal_id/deal_estimation_headers',
  show: '/vendors/deals/:deal_id/deal_estimation_headers/:id'
};

type TIndex = (dealId: number | null) => SwrReturnType<DealEstimationHeader[]>;
type TShow = (
  dealId: number | null,
  id: number | null
) => SwrReturnType<DealEstimationHistoryContext>;
type ReturnType = {
  index: TIndex;
  show: TShow;
};

export const useDealEstimationHeaders = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, isLoading, error } = useSWR<DealEstimationHeader[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading,
      error
    };
  };
  const show: TShow = (dealId: number | null, id: number | null) => {
    const { data, mutate, isLoading, error } =
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useSWR<DealEstimationHistoryContext>(
        dealId === null || id === null
          ? null
          : paths.show
              .replace(':deal_id', String(dealId))
              .replace(':id', String(id))
      );
    return {
      data: data ?? null,
      mutate,
      isLoading,
      error
    };
  };
  return { index, show };
};
